export default __webpack_public_path__ + "static/strollme_shooting_Feb_21-203_m-0947591fcd31f09449802dc3f5086ec3.jpg";